import type { TFrameOptions } from '../types';

/**
 * create a render node based on the render_to property
 */
export class RenderNodeBuilder {
  /**
   * create a parent to render into
   *
   * @param frameOptions
   * @returns
   */
  async create(frameOptions: TFrameOptions): Promise<HTMLElement | null> {
    const { render_to } = frameOptions;

    if (!render_to) {
      return this.__createParent(document.body.children[0]);
    }

    const anchorEl = document.body.querySelector(render_to) as HTMLElement | null;
    const isScriptQuery = render_to[0] === '[';
    if (isScriptQuery) {
      return this.__createParent(anchorEl);
    } else {
      return anchorEl;
    }
  }

  /**
   * find the element to render to
   *
   * @param frameOptions
   * @returns
   */
  async locate(frameOptions: TFrameOptions): Promise<HTMLElement | null> {
    const { render_to } = frameOptions;

    return render_to
      ? (document.body.querySelector(render_to) as HTMLElement | null)
      : (document.body.children[0] as HTMLElement | null);
  }

  private __createParent(anchorEl: Element | null) {
    if (!anchorEl) {
      return null;
    }

    const sectionEl = document.createElement('section');

    anchorEl.after(sectionEl);
    return sectionEl;
  }
}
